import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import '../studylogStyles.scss';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { useAppDispatch } from 'src/store/hooks';
import { archLevel } from 'src/data/config';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useSiteContactInfo } from '../../steps/useSitecontactinfo';
import DataGridConfirmationLetter from './DataGridConfirmationLetter';
import { useConfirmationVisit } from './useConfirmationLetter';
import { usePreferedDateFormat } from 'src/util/DateFormatter';

const ConfirmationVisitList: React.FunctionComponent<any> = ({ setStudyLogOpen, setProtocolQAOn }: any) => {
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  const handelBack = () => {
    if (isChanged) {
      setOpenConfirmExit(true);
    } else {
      if (openLetter) {
        setOpenLetter(false);
      } else {
        setProtocolQAOn(false);
        setStudyLogOpen(true);
      }
    }
  };
  const dispatch = useAppDispatch();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { checkPermission } = usePermissionWrapper();
  const { getSiteStudyPersonnelQueryData } = useSiteContactInfo();
  const { unSavedWarning } = useFieldTranslation();
  const {
    confirmationVisitDataError,
    confirmationVisitDataIsError,
    getConfirmationVisitData,
    confirmationPublishVisitDataError,
    confirmationPublishVisitDataIsError,
    getPublishConfirmationVisitData
  } = useConfirmationVisit();
  const [openLetter, setOpenLetter] = useState(false);
  const [rows, setRows] = React.useState([]);
  const [result, setResult] = useState<any>({});
  const [dataGridShow, setDataGridShow] = useState(false);
  const { getPreferredDateTimeInLocal } = usePreferedDateFormat();

  const getData = async () => {
    if (selectedSite) {
      try {
        const res: any = await getSiteStudyPersonnelQueryData({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME
        });
        setResult(res);
      } catch (error: any) {
        //Empty
      }
    }
  };
  const getConfirmationVisit = async () => {
    setDataGridShow(true);

    const temp = checkPermission('publishview_imvconfirmation_letter')
      ? await getPublishConfirmationVisitData({
          site_id: selectedSite,
          study_id: studyId,
          application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_TSDA_SLUG,
          country: selectedCountry
        })
      : await getConfirmationVisitData({
          site_id: selectedSite,
          study_id: studyId,
          application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_TSDA_SLUG,
          country: selectedCountry
        });
    const tempRows: any = [];
    if (temp.isSuccess) {
      temp?.data.map((Data: any) => {
        tempRows.push({
          id: Data.id,
          visit_name: Data.visit_name,
          site_id: Data.site_id,
          created_by: Data.created_by,
          updated_by: Data.updated_by,
          visit_type: Data.visit_type,
          start_date: getPreferredDateTimeInLocal(Data.start_date),
          updated_on: getPreferredDateTimeInLocal(Data.updated_on),
          major_version: Number(Data.major_version).toFixed(1).toString(),
          tp_document_meta_id: Data.tp_document_meta_id,
          tp_document_id: Data.tp_document_id
        });
      });
      if (tempRows.length > 0) {
        setRows(tempRows);
      }
    } else if (temp?.isError) {
      setRows([]);
    }
    setDataGridShow(false);
  };

  //Calling siteStudyPersonnel api on hierarchy level change
  useEffect(() => {
    getConfirmationVisit();
    getData();
  }, [studyId, selectedCountry, selectedSite, openLetter]);

  useEffect(() => {
    if (confirmationVisitDataIsError) {
      setRows([]);
      const err: any = confirmationVisitDataError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        return;
      }
      setDataGridShow(false);
    } else if (confirmationPublishVisitDataIsError) {
      setRows([]);
      const err: any = confirmationPublishVisitDataError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403: Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: 'Letter is not published',
            severity: 'error'
          })
        );
      }
      setDataGridShow(false);
    }
  }, [
    confirmationVisitDataIsError,
    confirmationVisitDataError,
    confirmationPublishVisitDataError,
    confirmationPublishVisitDataIsError
  ]);

  useEffect(() => {
    getConfirmationVisit();
  }, []);

  return (
    <div>
      <Loader />
      <Box className="mainBackBtnWrap">
        <Button startIcon={<ArrowBackIcon fontSize="small" />} onClick={handelBack}>
          {openLetter ? 'Back' : 'List of Logs'}
        </Button>
      </Box>
      <Box sx={{ width: '100%' }}>
        <DataGridConfirmationLetter
          rows={rows}
          isLoading={dataGridShow}
          result={result}
          openLetter={openLetter}
          setOpenLetter={setOpenLetter}
          isChanged={isChanged}
          setIsChanged={setIsChanged}
        />
      </Box>
      <PopupComponent
        open={openConfirmExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
            }}
            className="grey-btn"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
              setConfirmExitPopupVal(dispatch, false);
              setIsChanged(false);
              setOpenLetter(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </PopupComponent>
    </div>
  );
};
export default ConfirmationVisitList;
